exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".myVideo[data-v-73cb0275]{background:rgba(0,0,0,0.5)}\n", ""]);

// exports
